import { Link } from 'react-router-dom';
import {
  createAdviserViewRoute,
  createInvestorViewRoute,
  createOrganisationViewRoute,
} from 'adminConstants/routes';
import { styled } from '@mui/material';
import { ApiResponses } from 'lib/trpcClient';

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.rootColor,
}));

type FurtherUser = ApiResponses['furtherUser']['list']['results'][number];

export const LinkedAccountsColumn = ({
  linkedInvestors,
  linkedAdviser,
  linkedOrgUser,
}: {
  linkedInvestors: FurtherUser['linkedInvestors'];
  linkedAdviser: FurtherUser['linkedAdviser'];
  linkedOrgUser: FurtherUser['linkedOrgUser'];
}) => {
  if (!linkedInvestors.length && !linkedAdviser && !linkedOrgUser) {
    return <div>-</div>;
  }

  const rows: Array<React.ReactNode> = [];

  if (linkedInvestors.length) {
    linkedInvestors.forEach((investor) => {
      rows.push(
        <span key={investor.investorId}>
          <StyledLink to={createInvestorViewRoute(investor.investorId)}>
            {investor.fullName}
          </StyledLink>{' '}
          (Investor - {investor.firmName})
        </span>,
      );
    });
  }

  if (linkedAdviser) {
    rows.push(
      <span>
        <StyledLink to={createAdviserViewRoute(linkedAdviser.adviserId)}>
          {linkedAdviser.fullName}
        </StyledLink>{' '}
        (Adviser)
      </span>,
    );
  }

  if (linkedOrgUser) {
    rows.push(
      <span>
        <StyledLink
          to={createOrganisationViewRoute(linkedOrgUser.organisationId)}
        >
          {linkedOrgUser.fullName}
        </StyledLink>{' '}
        (Organisation User)
      </span>,
    );
  }

  return (
    <span>
      {rows.map((row, index) => (
        <span key={index}>
          {row}
          {index !== rows.length - 1 && ', '}
        </span>
      ))}
    </span>
  );
};

export default LinkedAccountsColumn;
